
<div id="ribbon">
  <div class="card-container">
    <div class="card-summary-title card-summary-ribbon">
      <h3 class="prominent">
        <div class="flex flex-horiz-space-bw flex-vert-center">
          <div>
            <!-- Cust 360 -->
            <span *ngIf="pageType=='customer360'"><i class="anticon anticon-user"></i> Umang Desai</span>&nbsp;
            <!-- Servicing -->
            <span *ngIf="pageType=='servicing'">{{srvcId}}</span>&nbsp;
            <nz-tag *ngIf="pageType=='servicing'" [nzColor]="'#2db7f5'">Non-Financial</nz-tag>
          </div>
          <div>
            <button nz-button nzType="default" nzSize="small" class="m-r-5" (click)="freezeToggle()">
              <span *ngIf="caseIsFrozen">Un-</span>Freeze
            </button>
            <!-- Mark as favourite -->
            <a class="clickable col-white">
              <i *ngIf="isStarred" (click)="starThis()" nz-icon type="star" theme="fill"></i>
              <i *ngIf="!isStarred" (click)="starThis()" nz-icon type="star" theme="outline"></i>
            </a>
          </div>
        </div>
      </h3>

      <div class="card-summary-ribbon-grid card-summary-ribbon-grid-customer360">
        <div>
          <div class="grid grid-3x grid-gap-10 p-b-10">
            <div><strong class="c-s-heading">Policy Number</strong> <a (click)="policyPanel(1)">P0030547</a></div>
            <div><strong class="c-s-heading">Policy Commencement</strong> 12 Nov 2018, 10:15 AM</div>
            <div><strong class="c-s-heading">Insured Name</strong> Umang Desai</div>
            <div><strong class="c-s-heading">Policy Cover </strong> Rs. 1.20 Cr</div>
            <div><strong class="c-s-heading">Policy Status </strong> <nz-tag [nzColor]="'#87d068'">Active</nz-tag></div>
            <div><strong class="c-s-heading">Premium Status </strong> <nz-tag [nzColor]="'#87d068'">PAID</nz-tag></div>
          </div>

          <div>
            <nz-tooltip nzTitle="3 done / 3 to do" nzPlacement="bottom" *ngIf="pageType=='servicing'">
              <nz-progress nz-tooltip [nzPercent]="percentCompleted" [nzSuccessPercent]="percentCompleted"
                           nzStatus="active"></nz-progress>
            </nz-tooltip>
          </div>

        </div>

        <div class="card-summary-ico-big">
          <div class="card-action-ico" (click)="modalUsrCallVideo=true">
            <i nz-icon nzType="video-camera" nzTheme="outline"></i>
            <span>Video Call</span>
          </div>
          <div class="card-action-ico" (click)="modalUsrCall=true">
            <i nz-icon nzType="mobile" nzTheme="outline"></i>
            <span>Call</span>
          </div>
        </div>

        <div class="card-summary-ribbon-links">
          <h5>Actions</h5>
          <a (click)="workflowPanel(1,1)" class="is-disabled"><i class="anticon anticon-profile"></i> Activity Timeline</a>
          <a (click)="workflowPanel(1)" class="is-disabled"><i class="anticon anticon-audit"></i> Workflow Audit</a>
          <a (click)="corresPanel(1)" class="is-disabled"><i class="anticon anticon-inbox"></i> Correspondence</a>
          <a (click)="policyPanel(1)"><i class="anticon anticon-file-protect"></i> View Policy</a>
          <a (click)="profilePanel(1)"><i class="anticon anticon-user"></i> View Profile</a>
          <!--<button nz-button [nzSize]="'small'" nzType="primary" nzGhost nz-popover nzTitle="Tasks Timeline" [nzContent]="tasksTimelineTemplate" nzPlacement="bottomRight">Track Tasks</button>-->
        </div>
        <div class="card-summary-ribbon-links">
          <h5>Supporting</h5>
          <a (click)="notesPanel(1)" class="is-disabled"><i class="anticon anticon-read"></i> Notes</a>
          <a (click)="docuPanel(1)" class="is-disabled"><i class="anticon anticon-paper-clip"></i> Documents</a>
          <a (click)="worksheetPanel(1)" class="is-disabled"><i class="anticon anticon-reconciliation"></i> <span class="text-t-capitalize">&nbsp;{{productTypeConfig?.productType}}</span> Worksheet</a>
          <a (click)="analyticsModal=true" class="is-disabled"><i class="anticon anticon-dot-chart"></i> Analytics</a>
        </div>
        <!--<div class="flex flex-both-center">
          <a href="javascript:void(0);" (click)="notesPanel(1)">
            <i nz-icon nzType="read" nzTheme="outline" class="cur-pointer topbar-icon d-b"
               nz-tooltip nzTitle="My Notes" nzPlacement="center">
            </i>
            <nz-badge nzStatus="error">
            <small class="f-s-09r">Notes </small>
            </nz-badge>
          </a>
          <a href="javascript:void(0);" (click)="notesPanel(1)">
            <i nz-icon nzType="read" nzTheme="outline" class="cur-pointer topbar-icon d-b"
               nz-tooltip nzTitle="My Notes" nzPlacement="center">
            </i>
            <nz-badge nzStatus="error">
            <small class="f-s-09r">Docments </small>
            </nz-badge>
          </a>
        </div>-->
      </div>

    </div>

  </div>
</div>


<div id="extras">
  <!-- Frozen ? -->
  <div class="m-t-20" *ngIf="caseIsFrozen">
  <span>
    <nz-alert nzType="error" nzCloseable nzMessage="This case is frozen. Unfreeze to resume work." nzShowIcon>
    </nz-alert>
  </span>
  </div>

  <!-- Pending Tasks ? -->
  <div class="m-t-20">
    <nz-alert nzType="info" nzCloseable nzMessage="Last correspondence was sent out 3 days ago" nzShowIcon>
    </nz-alert>
  </div>

</div>



<div id="tabs" class="m-t-20">

  <nz-tabset style="height:auto">

    <nz-tab [nzTitle]="'Service Requests'">
      <div class="tab-investigation" [ngClass]="{'inputs-are-disabled': false}">


        <div class="search-results m-t-20">
          <nz-table [nzData]="[0]" [nzShowPagination]="false" [nzScroll]="{x:'1500px'}">
            <thead>
            <tr>
              <th>SR ID</th>
              <th>Status</th>
              <th>Policy No</th>
              <th>Policy Commencement</th>
              <th>Endorsement Type</th>
              <th>Type</th>
              <th>Premium Change</th>
              <th>Credit/Debit</th>
              <th>Request Date</th>
              <th>Approval Date</th>
              <th>Actions</th>
            </tr>
            </thead>
            <tbody>
            <tr>
              <td><a (click)="serviceRequestModal('address')">#SR2990992</a></td>
              <td>Completed</td>
              <td><a (click)="policyPanel(1)">P9200199/JMSP</a><span class="d-b col-grey-dark">StandardHealth</span></td>
              <td>20 Mar 2019</td>
              <td>Financial</td>
              <td>Address Change</td>
              <td>3000</td>
              <td><span class="f-w-600 col-green">Cr</span></td>
              <td>15 Jan 2020 10:00 PM</td>
              <td>17 Jan 2020 9:50 AM</td>
              <td><!-- Actions--></td>
            </tr>
            <tr>
              <td><a (click)="serviceRequestModal('email')">#SR5060992</a></td>
              <td>Pending</td>
              <td><a (click)="policyPanel(1)">P9200199/JMSP</a><span class="d-b col-grey-dark">StandardHealth</span></td>
              <td>20 Mar 2019</td>
              <td>Non-financial</td>
              <td>Email ID Change</td>
              <td>-</td>
              <td>-</td>
              <td>15 Jan 2020 10:00 PM</td>
              <td></td>
              <td><!-- Actions--></td>
            </tr>
            <tr>
              <td><a (click)="serviceRequestModal('dob')">#SR2990002</a></td>
              <td>Completed</td>
              <td><a (click)="policyPanel(1)">P9200199/JMSP</a><span class="d-b col-grey-dark">StandardHealth</span></td>
              <td>20 Mar 2019</td>
              <td>Financial</td>
              <td>Date of Birth Change</td>
              <td>2500</td>
              <td><span class="f-w-600 col-red">Dr</span></td>
              <td>15 Jan 2020 10:00 PM</td>
              <td>17 Jan 2020 9:50 AM</td>
              <td><!-- Actions--></td>
            </tr>
            </tbody>
          </nz-table>
        </div>

      </div>
    </nz-tab>

    <nz-tab [nzTitle]="'Policies'">
      <div class="tab-investigation" [ngClass]="{'inputs-are-disabled': false}">
        <!-- POLICY/Policies -->
        <div class="heading-tab">
          <h3 class="heading"><i nz-icon nzType="file-protect" nzTheme="outline"></i> Policies</h3>
        </div>
        <div class="search-results m-t-20">
          <nz-table [nzData]="[0]" [nzShowPagination]="false">
            <thead>
            <tr>
              <th>Policy No</th>
              <th>Product</th>
              <th>Policy Status</th>
              <th>Premium Status</th>
              <th>Premium Paid Till</th>
              <th>Risk Commencement Date</th>
              <th>Actions</th>
            </tr>
            </thead>
            <tbody>
            <tr>
              <td><a (click)="policyPanel(1)">P9200199/JMSP</a></td>
              <td>StandardLife</td>
              <td>Issued</td>
              <td>Paid</td>
              <td>20 Mar 2020</td>
              <td>20 Mar 2020</td>
              <td>
                <!-- Action-->
              </td>
            </tr>
            <tr><!-- Show multiple policies only at Intimation stage -->
              <td><a (click)="policyPanel(1)">P9202390/JMSP</a></td>
              <td>StandardLife</td>
              <td>Issued</td>
              <td>Paid</td>
              <td>20 Mar 2020</td>
              <td>20 Mar 2020</td>
              <td><!--<a class="mutates-data does-delete" nz-popconfirm nzTitle="Remove Policy from intimation?"
                     nzOkText="Remove" nzCancelText="Cancel">
                Remove</a>--></td>
            </tr>
            </tbody>
          </nz-table>
        </div>
      </div>
    </nz-tab>

    <nz-tab [nzTitle]="'Claims'">
      <div class="tab-investigation" [ngClass]="{'inputs-are-disabled': false}">
        <div class="zero-ui">
          <i nz-icon nzType="file-protect" nzTheme="outline"></i>
          <h2>No Claims</h2>
          <p>Customer has not made any claims yet</p>
        </div>
      </div>
    </nz-tab>

    <!-- -- >
    <nz-tab [nzTitle]="'Basic Details'">
      <div class="tab-investigation" [ngClass]="{'inputs-are-disabled': false}">
      </div>
    </nz-tab>
    <!-- -->

  </nz-tabset>

</div>


<!-- ==================== REDUNDANT MODALS (DO NOT COPY AGAIN - THESE COMPONENTS EXIST IN MAIN PRODUCT )==================== -->
<!-- POLICY DETAILS -->
<nz-drawer [nzClosable]="true" [nzWidth]="390" [nzVisible]="policyPanelOpen" [nzPlacement]="'right'"
           nzTitle="#PLF-00001-0001 Details"
           [nzOffsetX]="profilePanelOpen ? 80 : 0"
           (nzOnClose)="policyPanel(0)">

  <!-- Dropdown to select policy -- >
  <div class="p-b-20">
    <nz-select nzShowSearch ngModel="P0030547" class="d-b w-100-pc">
      <nz-option [nzLabel]="'P0030547'" [nzValue]="'P0030547'"></nz-option>
      <nz-option [nzLabel]="'P0067008'" [nzValue]="'P0067008'"></nz-option>
    </nz-select>
  </div>
  <!-- -->

  <!-- All data below changes on above dropdown change -->
  <!-- Title -->
  <ng-container *nzDrawerContent>
  <div class="title-emphasis">
    <i class="title-ico anticon anticon-file-protect"></i>
    <div>
      <h4 class="p-0 m-0">StandardLife</h4>
      <span class="col-grey-dark">PLF-00001-0001</span>
    </div>
  </div>

  <!-- Summary -->
  <h3 class="p-b-20 f-w-600 f-s-1r">Details</h3>
  <div class="summary-container">
    <div>
      <span class="s-c-head">Policy No</span> PLF-00001-0001
    </div>
    <div>
      <span class="s-c-head">Policy Owner</span>
      <a (click)="profilePanel(1)">Umang Desai</a>
    </div>
    <div>
      <span class="s-c-head">Product</span> StandardLife
    </div>
    <div>
      <span class="s-c-head">Plan</span> Individual
    </div>
    <div>
      <span class="s-c-head">Package</span> SILVER
    </div>
    <div>
      <span class="s-c-head">Premium Status</span>
      <nz-tag [nzColor]="'#87d068'">PAID</nz-tag>
    </div>
    <div>
      <span class="s-c-head">Commencement Date</span>
      13-11-2018 <small class="d-b">(~5 months ago w.r.t Event Date)</small>
    </div>
    <div>
      <span class="s-c-head">Policy Expiry Date</span>
      <nz-badge nzStatus="success">12-11-2019 </nz-badge>
      <small class="d-b">(in 6 months w.r.t Event Date)</small>
    </div>
    <div>
      <span class="s-c-head">Total Sum Insured</span> Rs 1 Cr.
    </div>
    <div>
      <span class="s-c-head">Premium</span> Rs 5400
    </div>

  </div>

  <!-- Coverages -->
  <div class="p-t-20">
    <!--<h3 class="p-t-b-20 f-w-600 f-s-1r">Coverages</h3>-->
    <nz-table #smallTableofCoverages nzSize="small" [nzData]="[0]" [nzShowPagination]="false">
      <thead>
      <tr>
        <th>Coverage</th>
        <th>Sum Insured</th>
      </tr>
      </thead>
      <tbody>
      <tr>
        <td>Health Checkup</td>
        <td>Rs. 90,000</td>
      </tr>
      <tr>
        <td>Restore Benefits</td>
        <td>Rs. 1,00,000</td>
      </tr>
      <tr>
        <td>Ambulance Cost</td>
        <td>Rs. 50,000</td>
      </tr>
      </tbody>
    </nz-table>
  </div>
</ng-container>
</nz-drawer>
<!-- CUSTOMER PROFILE DETAILS -->
<nz-drawer [nzClosable]="true" [nzWidth]="390" [nzVisible]="profilePanelOpen" [nzPlacement]="'right'"
           nzTitle="Customer Profile"
           (nzOnClose)="profilePanel(0)">
<ng-container *nzDrawerContent>
  <!-- Title -->
  <div class="title-emphasis">
    <i class="title-ico anticon anticon-contacts"></i>
    <div>
      <h4 class="p-0 m-0">Umang Desai</h4>
      <span class="col-grey-dark">19 Dec 1990 (29 years)</span>
    </div>
  </div>

  <!-- Summary -->
  <div class="summary-container">
    <div>
      <span class="s-c-head">Insured Name</span> Umang Desai
    </div>
    <div>
      <span class="s-c-head">Gender</span> Male
    </div>
    <div>
      <span class="s-c-head">Product</span> StandardLife
    </div>
    <div>
      <span class="s-c-head">Date of Birth</span> 19-12-1990
    </div>
    <div>
      <span class="s-c-head"> Country Of Birth</span> India
    </div>
    <div>
      <span class="s-c-head">Citizenship</span> Indian
    </div>
  </div>

  <h3 class="heading heading-summary">Identity</h3>

  <div class="summary-container">
    <div>
      <span class="s-c-head">KTP</span> K-0123
    </div>
    <div>
      <span class="s-c-head">PAN</span> AUORT7827R
    </div>
  </div>

  <h3 class="heading heading-summary">Contact</h3>
  <div>
    <nz-table nzSize="small" [nzData]="[1]" [nzShowPagination]="false" class="p-b-20 d-b">
      <thead>
      <tr>
        <th>Email</th>
        <th></th>
      </tr>
      </thead>
      <tbody>
      <tr>
        <td>hemsworth@altizone.co</td>
        <td>Business</td>
      </tr>
      <tr>
        <td>chris.thor@gmail.com</td>
        <td>Personal</td>
      </tr>
      </tbody>
    </nz-table>
    <nz-table nzSize="small" [nzData]="[1]" [nzShowPagination]="false">
      <thead>
      <tr>
        <th>Phone</th>
        <th></th>
      </tr>
      </thead>
      <tbody>
      <tr>
        <td>+01-456-8973</td>
        <td>Business</td>
      </tr>
      <tr>
        <td>+91-9503144092</td>
        <td>Personal</td>
      </tr>
      </tbody>
    </nz-table>
  </div>

  <h3 class="heading heading-summary">Address</h3>

  <div class="summary-container">
    <div>
      <span class="s-c-head">Home</span> A/803, Ridge Bay, Krent Road, East State - 1009
    </div>
    <div>
      <span class="s-c-head">Business</span> Mimic Co. F43, WorkSpaze, East State - 1012
    </div>
  </div>
</ng-container>
</nz-drawer>

<!-- ==================== / REDUNDANT MODALS (DO NOT COPY AGAIN - THESE COMPONENTS EXIST IN MAIN PRODUCT )==================== -->



<!-- MODALS -->

<nz-modal [(nzVisible)]="modalUsrCallVideo" nzTitle="Video Call" [nzFooter]="null" nzClosable (nzOnOk)="modalUsrCallVideo=false" (nzOnCancel)="modalUsrCallVideo=false">
  <ng-container *nzModalContent>
  <div class="cust-call-modal">

    <div class="video-call-container">
      <!-- CALL-->
      <div class="flex flex-both-center clickable flex-dir-vert" (click)="videoCall(true)" *ngIf="!videoCallOngoing" style="min-height: 350px; background: #f8f8f8">
        <a>
          <i nz-icon nzType="video-camera" nzTheme="outline" style="font-size: 5rem;color: #999" class="d-b p-b-20"></i>
          <b class="f-s-09r">Begin Call</b>
        </a>
      </div>
      <!-- ON CALL -->
      <div *ngIf="videoCallOngoing">
        <video controls autoplay loop width="100%" height="auto" controlsList="nodownload">
          <source [src]="'/assets/images/demo/videocall.webm'" type="video/mp4">
          Your browser does not support the <code>video</code> element.
        </video>
        <div class="flex flex-horiz-space-bw p-t-5">
          <small class="d-b f-s-09r col-red p-t-b-5">
            <i nz-icon [type]="'sync'" [spin]="true"></i> Recording ...
          </small>
          <button nz-button nzType="danger">Hangup Call</button>
        </div>
        <label for="srvcing" class="d-b p-t-b-5">Service Request</label>
        <nz-select nzShowSearch [ngModel]="'#SR6790977'" id="srvcing" class="d-b w-100-pc">
          <nz-option [nzLabel]="'N.A'" [nzValue]="'#0'"></nz-option>
          <nz-option [nzLabel]="'#SR6790977 [Address Change - Pending]'" [nzValue]="'#SR6790977'"></nz-option>
          <nz-option [nzLabel]="'#SR5060992 [Email ID Change - Closed]'" [nzValue]="'#SR5060992'"></nz-option>
          <nz-option [nzLabel]="'#SR2990005 [Date of Birth Change - Closed]'" [nzValue]="'#SR2990005'"></nz-option>
        </nz-select>
        <label for="notes-for-video" class="d-b p-t-b-5">Notes</label>
        <textarea nz-input name="" cols="30" rows="4" placeholder="Write your notes ..." id="notes-for-video">Customer (Chris) was not available and Rhea (spouse) picked the call. She verified the authenticity of the address change document uploaded (Chris' Passport) by holding it up against the webcam</textarea>
        <div class="flex flex-horiz-space-bw p-t-20">
          <button nz-button nzType="default" (click)="videoCall(false)">Close</button>
          <button nz-button [nzType]="'primary'">Save Note</button>
        </div>
      </div>
    </div>

    <nz-divider nzText="Call Log" nzOrientation="left"></nz-divider>
    <ul class="ul-spaced" (click)="videoCall(true)">
      <li><a><i nz-icon nzType="video" nzTheme="outline"></i> VideoCall-12-apr-2019-10:00am</a> #SR5060992</li>
      <li><a><i nz-icon nzType="video" nzTheme="outline"></i> VideoCall-10-apr-2019-09:00am</a> #SR5060992</li>
      <li><a><i nz-icon nzType="video" nzTheme="outline"></i> VideoCall-21-mar-2019-10:00pm</a> #SR2990005</li>
    </ul>
  </div>
  </ng-container>
</nz-modal>
<nz-modal [(nzVisible)]="modalUsrCall" nzTitle="Audio Call" [nzFooter]="null" nzClosable (nzOnOk)="modalUsrCall=false" (nzOnCancel)="modalUsrCall=false">
  <ng-container *nzModalContent>
  <div class="cust-call-modal">
    <img src="/assets/images/demo/audiocall.jpg" alt=""/>
    <nz-divider nzText="Call Log" nzOrientation="left"></nz-divider>
    <ul class="ul-spaced">
      <li><a><i nz-icon nzType="audio" nzTheme="outline"></i> AudioCall-12-apr-2019-10:00am</a>  #SR5060992</li>
      <li><a><i nz-icon nzType="audio" nzTheme="outline"></i> AudioCall-10-apr-2019-09:00am</a>  #SR5060992</li>
      <li><a><i nz-icon nzType="audio" nzTheme="outline"></i> AudioCall-21-mar-2019-10:00pm</a>  #SR2990005</li>
    </ul>
  </div>
  </ng-container>
</nz-modal>



<nz-modal [(nzVisible)]="srModal" nzTitle="Service Request: #SR7849992" [nzFooter]="null" nzClosable (nzOnOk)="srModal=false" (nzOnCancel)="srModal=false" nzWidth="860px">
  <ng-container *nzModalContent>
  <div class="inputs-are-disabled----">
    <app-servicing-request-form [formType]="srType"></app-servicing-request-form>
  </div>

  <!-- Separator -->
  <nz-divider [nzText]="'Assignee Details'" [nzOrientation]="'left'" class=""></nz-divider>

  <!-- Assigned to -->
  <div class="sr-user-info p-t-15">
    <div class="grid grid-gap-0 grid-2x grid-2x-responsive">
      <div class="">
        <h4 class="d-i-b m-r-10">Assigned to</h4>
        <nz-avatar nzSize="small" nzIcon="user"></nz-avatar>&nbsp;
        John Doe
      </div>
      <p><b>Assigned on:</b> 30 Apr 2020, 06:19 pm</p>
      <p><b>Status:</b> Completed</p>
      <p><b>Completed on:</b> 01 May 2020, 11:45 am</p>
    </div>
  </div>
  </ng-container>
</nz-modal>
